require("./transactionHistoryDirective");

"use strict";

angular.module('app.myProfile.transactionHistory', [
    'app.myProfile.transactionHistory.transactionHistoryDirective'
]);


// WEBPACK FOOTER //
// ./app.v2/components/myProfile/transactionHistory/transactionHistory.js